import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const TZ_MX = "America/Mexico_City";
/** Fecha (YYYY-MM-DD) de un instante en la zona horaria del centro de México. */
export function fechaMX(d = new Date()) {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: TZ_MX, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date(d));
  const g = (t) => p.find((x) => x.type === t).value;
  return `${g("year")}-${g("month")}-${g("day")}`;
}
export const hoyMX = () => fechaMX(new Date());
